<template>
    <div class="form-item">
        <div class="form-item__label">户型需求（可多选）：</div>
        <div class="form-item__body filter-radio">
            <div :class="['form-item__body_input wrapper radio filter-radio__item qudra filter-radio__item_noicon', item.selected ? 'active' : '']"
            v-for="(item, index) in layouts" :key="index" @click="select(index)">
                <div class="form-item__body_input_text">{{item.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['info'],
        data () {
            return {
                layouts: [
                    // {name: '合作单间', value: 'single', selected: false},
                    {name: '整租单间', value: 'entire', selected: false},
                    {name: '整租1室', value: 'entire1', selected: false},
                    {name: '整租2室', value: 'entire2', selected: false},
                    {name: '整租3室+', value: 'entire3', selected: false}
                ]
            }
        },
        methods: {
            select (index) {
                const layouts = []
                this.layouts[index].selected = !this.layouts[index].selected
                for (let i = 0; i<this.layouts.length; i++) {
                    if (this.layouts[i].selected) {
                        layouts.push(this.layouts[i].value)
                        this.info.layout = layouts.join(',')
                    }
                }
            }
        }
    }
</script>

